import { Injectable } from "@angular/core";
import { SchemaDefinition } from "src/app/schema/validator/schema-definition-interface";
import { IModuleValidationService } from "src/app/schema/validator/module-validation-service-interface";
import { SchemaValidator } from "src/app/schema/validator/schema-validator";
import { storedAccessoryServiceInstance, storedCustomerInstance, storedDatePartInstance, storedDocumentInformationInstance, storedLocationInstance, storedPieceInstance, storedReferenceNumberInstance, storedServiceActionInstance, storedServiceNoteInstance, storedSignatureEntryInstance, storedSignedDocumentPageInstance, storedTimePartInstance } from "../model-instances";
import { storedAccessoryServiceSchema, storedCustomerSchema, storedDatePartSchema, storedDocumentInformationSchema, storedLocationSchema, storedPieceSchema, storedReferenceNumberSchema, storedServiceActionSchema, storedServiceNoteSchema, storedSignatureEntrySchema, storedSignedDocumentPageSchema, storedTimePartSchema } from "../schema-instances";

/**
 * A service that validates the schema of the root directory models.
 */
@Injectable()
export class SchemaValidationService implements IModuleValidationService {

	/**
	 * The collection of model instance -> schema definition pairings to be validated
	 */
	private schemaCollection: [any, SchemaDefinition][] = [
		[storedDocumentInformationInstance, storedDocumentInformationSchema],
		[storedServiceNoteInstance, storedServiceNoteSchema],
		[storedSignatureEntryInstance, storedSignatureEntrySchema],
		[storedSignedDocumentPageInstance, storedSignedDocumentPageSchema],
		[storedSignatureEntryInstance, storedSignatureEntrySchema],
		[storedReferenceNumberInstance, storedReferenceNumberSchema],
		[storedAccessoryServiceInstance, storedAccessoryServiceSchema],
		[storedPieceInstance, storedPieceSchema],
		[storedLocationInstance, storedLocationSchema],
		[storedDatePartInstance, storedDatePartSchema],
		[storedTimePartInstance, storedTimePartSchema],
		[storedCustomerInstance, storedCustomerSchema],
		[storedServiceActionInstance, storedServiceActionSchema]
	];

	/**
	 * Passes this service's instance->schema pairings to the schema validator.
	 */
	ValidateModels() {
		SchemaValidator.ValidateModels(this.schemaCollection);
	}
}